export default __webpack_public_path__ + "static/media/advicegradissuegfx-08.c44b7959.png";